/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Rights_Form {
    Edit = 'Form.Edit',
    View = 'Form.View',
}
